import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {AppState} from '../Store';
import {Dashboard} from '../Services/DashboardService';

interface HeaderProps {
  dashboard: Dashboard;
}

function Header({dashboard}: HeaderProps) {
  const {articles, authors, categories, errors, metrics, surveys} = dashboard;

  return (
    <div className="world-category-area">
      <ul className="nav nav-tabs" role="tablist">
        <li className="title"><Link to="/admin">Dashboard</Link></li>
        <li className="nav-item"><Link className="nav-link" to="/admin/articles">Articles ({articles.count})</Link></li>
        <li className="nav-item"><Link className="nav-link" to="/admin/authors">Authors ({authors.count})</Link></li>
        <li className="nav-item"><Link className="nav-link" to="/admin/categories">Categories ({categories.count})</Link></li>
        <li className="nav-item"><Link className="nav-link" to="/admin/surveys">Surveys ({surveys.count})</Link></li>
        <li className="nav-item"><Link className="nav-link" to="/admin/metrics">Metrics ({metrics.count})</Link></li>
        <li className="nav-item"><Link className="nav-link" to="/admin/errors">Errors ({errors.count})</Link></li>
      </ul>
    </div>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    dashboard: state.admin.dashboard,
  };
};

export default connect(mapStateToProps)(Header);
